import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductStoreRoutingModule } from './product-store-routing.module';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { Router } from '@angular/router';
import { AppInitConfigService, ConfigurationService } from '@urbannex/configuration';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { take } from 'rxjs';

@Component({
  selector: 'ngx-product-store',
  standalone: true,
  imports: [CommonModule,UbsViewContainersModule],
  templateUrl: './product-store.component.html',
  styleUrls: ['./product-store.component.scss']
})
export class ProductStoreComponent implements OnInit{
  MENU_ITEMS:NbMenuItem[] = [];
  headerTitle:string = "product store";
  path:string = "product-store";
  menuTag:string = "productStoreMenu"
  menuAndTitleOptions = {path:this.path,menuItems:this.MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};
  
  constructor(
    private router:Router,
    private viewContainersService:ViewContainersService,
    private configurationService:ConfigurationService,
    private menuService:NbMenuService) {
      this.viewContainersService.addMenuAndTitleOptions(this.menuAndTitleOptions) 
      console.log("path: "+this.router.url);
      let parts = this.router.url.split("/");
      this.getMenuTitle(parts[2]);
      console.log("parts: "+parts);
    if(this.router.url.includes("/cms")){

    }
  }

  ngOnInit(): void {
    /* setTimeout(() => {
      this.store.blogs$.pipe(take(1)).subscribe(blogs => {
        let menuItems:NbMenuItem[] = [];
        let menuTag = "blogMenu";
        let groupItem:NbMenuItem = {"title":"Blogs","group":true};
        menuItems.push(groupItem);
        blogs.forEach(blog => {
          let menuItem:NbMenuItem = {"title":blog.contentName};
          let link = "/admin/blog/"+blog.blogContentId;
          menuItem.link = link;
          console.log(blog.blogEntries);
          let blogChildren:NbMenuItem[] = [];
          blogChildren.push({"title":"Edit","link":"/admin/blog/"+blog.blogContentId+"/update","icon":'edit-outline'});
          blogChildren.push({"title":"List Articles","link":"/admin/blog/"+blog.blogContentId+"/articles","icon":"list-outline"});
          blogChildren.push({"title":"Create Article","link":"/admin/blog/"+blog.blogContentId+"/new","icon":'plus-outline',})
          if(blog.blogEntries != undefined && blog.blogEntries.length > 0){
            blogChildren.push({"title":"Articles","group":true})
            blog.blogEntries.forEach(entry => {
              let childMenuItem:NbMenuItem = {"title":entry.contentName};
              childMenuItem.link = "/admin/blog/"+blog.blogContentId+"/article/"+entry.contentId;
              blogChildren.push(childMenuItem);
            });
          }
          menuItem.children = blogChildren;
          menuItems.push(menuItem);
        })
        console.log(menuItems)
        this.menuService.addItems(menuItems,menuTag);
        })
    }, 500); */
  }

  getMenuTitle(path){
    setTimeout(() => {
      let menuItemsAndOptions = this.viewContainersService.getMenu(path);
      if(menuItemsAndOptions){
        console.log("menuTitle:"+menuItemsAndOptions.headerTitle);
        let menuItems:NbMenuItem[] = [];
        menuItems.push({"title":"Product Stores","group":true});
        this.menuService.addItems(menuItems,menuItemsAndOptions.menuTag);
        /* this.menu = menuItemsAndOptions.menuItems;
        this.headerTitle = menuItemsAndOptions.headerTitle;
        this.menuTag = menuItemsAndOptions.menuTag;
        console.log(this.menuTag) */
      }
    },500)
    
  }
}
